import { Link  } from "react-router-dom"; 
import { FcAddRow} from "react-icons/fc";
const InnerNav = ({createLink, listLink})=>{
    return (
        <div className="flex flex-col flex-wrap mb-8 space-y-4 md:flex-row md:items-end md:space-x-4">
            <div>
                <Link to={createLink} className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-gray-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                >
                  <FcAddRow />
                  <span className="ml-2">New</span>
                </Link>
            </div>

            {/* <div>
            <Link to={listLink} className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-gray-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                >
                  <FcList/>
                  <span className="ml-2">Liste </span>
                </Link>
            </div> */}


        </div>
    );
};
export default InnerNav;